
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SignupDisabledAlertProps {
  onBackToLogin: () => void;
}

export const SignupDisabledAlert = ({ onBackToLogin }: SignupDisabledAlertProps) => {
  return (
    <div className="mb-6 p-4 bg-destructive/10 rounded-md border border-destructive/20 text-sm flex items-start gap-3">
      <AlertCircle className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
      <div>
        <h3 className="font-medium text-destructive">التسجيل معطل</h3>
        <p className="mt-1 text-muted-foreground">
          تسجيل المستخدمين معطل حالياً في هذا النظام. يرجى التواصل مع المدير لطلب حساب.
        </p>
        <Button 
          type="button" 
          variant="outline"
          size="sm"
          onClick={onBackToLogin}
          className="mt-3"
        >
          العودة لتسجيل الدخول
        </Button>
      </div>
    </div>
  );
};
